import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Button } from 'components/molecules/orders/List/styled';
import { ReactComponent as DeleteIcon } from 'assets/images/delete.svg';
import routeCodes from 'common/constants/route-codes';
import { Wrapper, Row, RowItem, Delete } from './styled';
import { Divider } from 'components/atoms/styleds';

const getDuration = (duration) => {
  const [time = '', text = ''] = duration?.split('_');
  return `${time} ${text}`;
};

const ServicesList = ({
  list = [],
  inProcess,
  onDelete,
  isSuperAdmin,
  currentRestaurant,
}) => {
  const createRoute = isSuperAdmin
    ? routeCodes.superAdmin.settingsConfigsServicesView.replace(
        ':restaurantId',
        currentRestaurant?.id,
      )
    : routeCodes.settingsConfigsServicesView;
  return (
    <Wrapper>
      <Row isTitle={true}>
        <RowItem title={true}>Nome servizio</RowItem>
        <RowItem hiddenMobile={true} title={true}>
          Totale coperti{' '}
        </RowItem>
        <RowItem hiddenMobile={true} title={true}>
          Durata media del servizio
        </RowItem>
      </Row>
      <Divider />
      {list?.map((i, index) => (
        <Fragment key={i.id}>
          <Row>
            <RowItem>{i.title}</RowItem>
            <RowItem hiddenMobile={true}>
              <span style={{ paddingLeft: 30 }}>{i.total_seats}</span>
            </RowItem>
            <RowItem>
              <RowItem
                hiddenMobile={true}
                style={{ display: 'block', textAlign: 'center' }}
              >
                {getDuration(i.service_duration)}
              </RowItem>
              <RowItem justify='flex-end'>
                <Button
                  as={Link}
                  to={createRoute.replace(':id', i.id)}
                  mt={0}
                  mr={20}
                  bgColor='#FF7828'
                >
                  Modifica
                </Button>
                <Delete
                  as={DeleteIcon}
                  disabled={inProcess}
                  role='presentation'
                  onClick={() => onDelete(i)}
                />
              </RowItem>
            </RowItem>
          </Row>
          {index !== list?.length - 1 && <Divider />}
        </Fragment>
      ))}
    </Wrapper>
  );
};

export default ServicesList;
